import { vadDetector } from "../audio/vadDetector"

/**
 * Pipeline to process raw audio buffers and tag them with human detection metadata.
 */
export async function processAudioChunk(batch, currentModelId, classId, isHumanFromTF = false) {
  try {
    const isHumanCandidate = vadDetector.isSpeechDetected()
    const timestamp = Date.now()

    // Architecture: Raw data combined with real-time VAD state and TF.js results
    const sample = {
      modelId: currentModelId,
      classId: classId,
      sampleType: 'Audio',
      timestamp: timestamp,
      isHumanCandidate: isHumanCandidate,
      isHumanFromTF: isHumanFromTF,
      sampleData: (() => {
        // Use Float32Array.set() — avoids converting each chunk to a regular JS array
        // and eliminates the large temporary allocations from flatMap + Array.from.
        const totalLength = batch.reduce((sum, b) => sum + b.data.length, 0)
        const combined = new Float32Array(totalLength)
        let offset = 0
        for (const b of batch) {
          combined.set(b.data, offset)
          offset += b.data.length
        }
        return { data: combined, frameSize: batch[0].frameSize }
      })()
    }

    return sample
  } catch (e) {
    console.error("ProcessAudio: Pipeline error", e)
    throw e
  }
}
